const Subscription = {
    UPDATE_INGESTION_JOB_STATUS: `
        subscription UpdateIngestionJobStatus($ingestionjobid: ID!) {
            updateIngestionJobStatus(ingestionjobid: $ingestionjobid) {
                ingestionjobid
                files {
                    name
                    status
                    imageurl
                }
            }
        }
    `,
    UPDATE_QA_JOB_STATUS: `
        subscription UpdateQAJobStatus($jobid: ID!) {
            updateQAJobStatus(jobid: $jobid) {
                question
                answer
                jobstatus
            }
        }
    `,
};

export default Subscription;
